import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Star, MessageCircle, ArrowRight } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";
import { Stars } from "@/components/games/GameCards";

export default function GameOfWeek() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/gamehub/weekly").then((r) => setD(r.data)).catch(() => setD({ game: null })); }, []);
  const g = d?.game;
  if (!g) return null;
  return (
    <section data-testid="game-of-week">
      <Link to={`/games/${g.id}`} className="group relative block rounded-3xl overflow-hidden border border-white/10">
        <img src={mediaUrl(g.img)} alt={g.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/75 to-black/20" />
        <div className="relative p-5 md:p-7 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
          <div className="min-w-0 flex-1">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-400 text-black text-[11px] font-bold uppercase tracking-wider"><Trophy size={12} /> Game of the Week</span>
            <h2 className="mt-3 text-2xl md:text-4xl font-bold text-white leading-tight truncate" data-testid="gotw-name">{g.name}</h2>
            <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-white/60">
              <span className="inline-flex items-center gap-1.5"><Star size={16} className="text-yellow-400 fill-yellow-400" /><b className="font-head text-lg text-white" data-testid="gotw-rating">{g.rating_count ? g.rating_avg.toFixed(1) : "–"}</b>/10</span>
              <Stars value={g.rating_avg} size={14} />
              <span data-testid="gotw-week-stats" className="inline-flex items-center gap-3 text-xs text-white/50">
                {d.source === "weekly" ? <><span>{d.week_ratings} ratings this week</span><span className="inline-flex items-center gap-1"><MessageCircle size={12} /> {d.week_comments}</span></> : <span>{g.publisher}</span>}
              </span>
            </div>
          </div>
          <span className="shrink-0 self-start md:self-center inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] font-bold text-sm group-hover:brightness-110" data-testid="gotw-view">View game <ArrowRight size={15} /></span>
        </div>
      </Link>
    </section>
  );
}
